import {MessageCodes} from "../MessageCodes";
import {useAppContext} from "../../../context/AppContext";
import ResultView from "../../../components/ResultView";
import ResultText from "../ResultText";
import EmptyLine from "../EmptyLine";
import Plural from "../../../components/Plural";
import ResultTable from "../../../components/table/ResultTable";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultBody from "../../../components/table/ResultBody";
import ResultRow from "../../../components/table/ResultRow";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import HecRasHelper from "../../../helpers/HecRasHelper";

const Line = ({children}) => (
    <ResultRow>
        <ResultBodyCell style={{textAlign: 'left'}}>{children}</ResultBodyCell>
    </ResultRow>
)

export function OV2({message_key}) {
    const {getSelectedHistory} = useAppContext()
    const summary = getSelectedHistory()?.summary?.base

    return (
        <ResultView error_id={MessageCodes.Internal.OV02.error_id} message_key={message_key}>
            <ResultText>
                The plan includes the following geometry and flow data.
            </ResultText>
            <EmptyLine/>
            <ResultTable>
                <ResultHeader>
                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(40)}}>Geometry and Flow</ResultHeaderCell>
                    </ResultRow>
                </ResultHeader>
                <ResultBody>
                    <Line>{summary?.length} feet ({(summary?.length / 5280).toFixed(2)} miles)</Line>
                    <Plural
                        count={summary?.crossSections}
                        singular={'cross section'}
                        plural={'cross sections'}
                        render={(count, text) => (<Line>{count} {text}</Line>)}
                    />
                    <Plural
                        count={summary?.single_bridge}
                        singular={'(single opening) bridge'}
                        plural={'(single opening) bridges'}
                        render={(count, text) => (<Line>{count} {text}</Line>)}
                    />
                    <Plural
                        count={summary?.multiple_bridge}
                        singular={'multiple openings'}
                        plural={'multiple openings'}
                        render={(count, text) => (<Line>{count} {text}</Line>)}
                    />
                    <Plural
                        count={summary?.culverts}
                        singular={'culvert'}
                        plural={'culverts'}
                        render={(count, text) => (<Line>{count} {text}</Line>)}
                    />
                    <Plural
                        count={summary?.inline}
                        singular={'inline structure'}
                        plural={'inline structures'}
                        render={(count, text) => (<Line>{count} {text}</Line>)}
                    />
                    <Plural
                        count={summary?.profiles}
                        singular={'profile'}
                        plural={'profiles'}
                        render={(count, text) => (
                            <Line>
                                {count} {text}
                                <Plural
                                    count={summary?.flowLocations}
                                    singular={'location'}
                                    plural={'locations'}
                                    render={(c, t) => ` with ${c} flow change ${t}`}
                                />
                            </Line>
                        )}
                    />
                </ResultBody>
            </ResultTable>
        </ResultView>
    )
}
